// palette reads a color of the active theme (spec 010) from the Catppuccin
// variables app.css defines, for drawing that cannot use CSS: map overlay
// paint and canvases. Read it when drawing, since the theme can change.
export type PaletteColor =
  | 'rosewater' | 'flamingo' | 'pink' | 'mauve' | 'red' | 'maroon' | 'peach' | 'yellow' | 'green' | 'teal'
  | 'sky' | 'sapphire' | 'blue' | 'lavender' | 'text' | 'subtext1' | 'subtext0' | 'overlay2' | 'overlay1'
  | 'overlay0' | 'surface2' | 'surface1' | 'surface0' | 'base' | 'mantle' | 'crust';

export function palette(name: PaletteColor): string {
  return getComputedStyle(document.documentElement).getPropertyValue(`--theme-${name}`).trim();
}
